import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ChannelsList from './ChannelsList/ChannelsList';
import PromotionsList from './PromotionsList/PromotionsList';

const PromoteContainer = ({ promotions, }) => {
  const activeChannels = promotions.map(({ channel_id, }) => channel_id);
  return (
    <div>
      <PromotionsList promotions={promotions} />
      <ChannelsList activeChannels={activeChannels} />
    </div>
  );
};

PromoteContainer.propTypes = {
  promotions: PropTypes.arrayOf(PropTypes.object),
};

PromoteContainer.defaultProps = {
  promotions: [],
};

const mapStateToProps = (state) => {
  return {
    promotions: state.promotions.promotions,
  };
};

export default connect(mapStateToProps)(PromoteContainer);
